<template>
  <div class="progressbar">
    <span
      :style="{width: currentProgress}"
      :class="{isError}"></span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: [Number, String],
      default: 0
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentProgress () {
      return Math.min(this.progress, 100) + '%'
    }
  }
}
</script>

<style lang="scss">
.progressbar {
  display: block;
  height: $size-grid / 3;
  background: $gray-very-light;
  position: relative;
  span {
    background: $cyan;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: width 0.2s linear;

    &.isError {
      background: $color-error;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/ProgressBar.vue